export default {"src":"/_next/static/media/link.cf726190.svg","height":28,"width":28,"blurWidth":0,"blurHeight":0};